export default "__VITE_ASSET__DRp_zCJC__"